import React from "react";
import { setChatWidgetInnitialized } from "../../action/action";
import { ZINGLE_DEMO, ZINGLE_ANDROIDID , ZINGLE_IOSID } from "../../../config/constant"
import { freshchatWidgetInitialize } from "./freshchat";
import { zingleWidgetInitialize } from "./zingle";
import { zingleWebWidgetInitialize } from "./zingleWeb";
import { FreshchatWebWidgetInitialize } from "./freshchatWeb";
import { InnspireChatInitialize } from "./innpirechatbot";
import { InitScriptChatBot } from "./scriptChatbot";


export const initializeChat = (props, callback) => {

    try {
        if (props.freshChatData.login.interfaceKey == "FRESHCHAT") {
            if(window.device){
                freshchatWidgetInitialize(props, (callbackStatus) => {
                    if(callbackStatus){
                        callback(true)
                    }
                })
            } else {
                FreshchatWebWidgetInitialize(props, (callbackStatus) => {
                    if(callbackStatus){
                        callback(true)
                    }
                })
            }
        }
        else if (props.freshChatData.login.interfaceKey == "ZINGLE") {
            if(window.device){
                zingleWidgetInitialize(props, (callbackStatus) => {
                    if(callbackStatus){
                        callback(true)
                    }
                })
            } else {
                zingleWebWidgetInitialize(props, (callbackStatus) => {
                    if(callbackStatus){
                        callback(true)
                    }
                })
            }
        }
        else if (props.freshChatData.login.interfaceKey.toLowerCase() == "innspirechat") {
            InnspireChatInitialize(props, (callbackStatus) => {
                if (callbackStatus) {
                    callback(true)
                }
            })
            callback(true);
        } else if (props.freshChatData.login.interfaceKey.toLowerCase() == "scriptchatbot"){
            InitScriptChatBot(props, (callbackStatus) => {
                if (callbackStatus) {
                    callback(true)
                }
            })
            callback(true);
        }
    } catch (error) {
        console.log("Error while initializing the freshchat/Zingle", error)
        if (window.FirebasePlugin) {
            window.FirebasePlugin.logError("Error while initializing the freshchat/Zingle", error)
        }
    }
    callback(false)
} 